/**
 * Constantes centralisées pour l'application
 */

// Délais et timeouts
export const DELAYS = {
  STATE_UPDATE: 500, // ms - Délai pour mise à jour d'état
  NETWORK_RETRY_INITIAL: 1000, // ms - Délai initial pour retry réseau
  NETWORK_RETRY_MAX: 10000, // ms - Délai maximum pour retry réseau
  TIMING_PROTECTION: 500, // ms - Délai constant pour protection timing
  CACHE_TTL: 30000, // ms - 30 secondes pour cache d'accès
  ENROLLMENT_INTENT_EXPIRATION: 24 * 60 * 60 * 1000 // 24 heures
}

// Nombre de tentatives
export const RETRY_CONFIG = {
  MAX_RETRIES: 3,
  NETWORK_MAX_RETRIES: 3
}

// Messages d'erreur standardisés
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Erreur de connexion. Vérifiez votre connexion internet.',
  TIMEOUT_ERROR: 'La requête a pris trop de temps. Veuillez réessayer.',
  SERVER_ERROR: 'Erreur serveur. Veuillez réessayer plus tard.',
  UNAUTHORIZED: 'Vous devez être connecté pour accéder à cette ressource.',
  FORBIDDEN: 'Vous n\'avez pas l\'autorisation d\'accéder à cette ressource.',
  NOT_FOUND: 'Ressource non trouvée.',
  VALIDATION_ERROR: 'Les données fournies ne sont pas valides.',
  UNKNOWN_ERROR: 'Une erreur inattendue s\'est produite.'
}

// Types d'actions d'erreur
export const ERROR_ACTIONS = {
  REDIRECT: 'redirect',
  ENROLL: 'enroll',
  EXPIRED: 'expired',
  CERTIFICATE: 'certificate',
  BLOCKED: 'blocked',
  ERROR: 'error'
}

